export type ItsmWarehouseListResponse = {
  warehouses: ItsmWarehouseModel[];
  pageLength: number;
  pageNumber: number;
  totalStagingWarehouseCount: number;
};

export interface ItsmWarehouseModel {
  stagingWarehouseId: string;
  name: string;
  modCoordinator: ModCoordinator;
  contact: Contact;
  address: Address;
}

interface ModCoordinator {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

interface Contact {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

interface Address {
  city: string;
  country: string;
  countryName: string;
  line1: string;
  line2: string;
  name1: string;
  name2: string;
  postalCode: string;
  region: string;
  regionAbbreviation: string;
  regionName: string;
}

export function itsmWarehouseModelFactory(json?: any): ItsmWarehouseModel {
  json = json || {};

  return {
    stagingWarehouseId: json.stagingWarehouseId || "",
    name: json.name || "",
    modCoordinator: {
      email: json.modCoordinator.email || "",
      firstName: json.modCoordinator.firstName || "",
      lastName: json.modCoordinator.lastName || "",
      phoneNumber: json.modCoordinator.phoneNumber || "",
    },
    contact: {
      email: json.contact.email || "",
      firstName: json.contact.firstName || "",
      lastName: json.contact.lastName || "",
      phoneNumber: json.contact.phoneNumber || "",
    },
    address: {
      city: json.address.city || "",
      country: json.address.country || "",
      countryName: json.address.countryName || "",
      line1: json.address.line1 || "",
      line2: json.address.line2 || "",
      name1: json.address.name1 || "",
      name2: json.address.name2 || "",
      postalCode: json.postalCode || "",
      region: json.address.region || "",
      regionAbbreviation: json.address.regionAbbreviation || "",
      regionName: json.address.regionName || "",
    },
  };
}

export function itsmWarehouseModelListFactory(json?: any): ItsmWarehouseModel[] {
  return Array.from(json || []).map(it => itsmWarehouseModelFactory(it)) as ItsmWarehouseModel[];
}

export function itsWarehouseAddressesModelFactory(json?: any): ItsmWarehouseListResponse {
  json = json || {};

  return {
    warehouses: itsmWarehouseModelListFactory(json.stagingWarehouses) || [],
    pageLength: json.pageLength || 0,
    pageNumber: json.pageNumber || 0,
    totalStagingWarehouseCount: json.totalStagingWarehouseCount || 0,
  };
}
